module.exports = __webpack_public_path__ + "static/media/partner1.af62ef31.png";